import {
    BreadcrumbsDispatcher as SourceBreadcrumbsDispatcher
} from 'SourceStore/Breadcrumbs/Breadcrumbs.dispatcher';

/** @namespace Bodypwa/Store/Breadcrumbs/Dispatcher */
export class BreadcrumbsDispatcher extends SourceBreadcrumbsDispatcher {
    // TODO implement logic
    _getCategoryBreadcrumbs(category) {
        const { url, name, breadcrumbs } = category;
        const breadcrumbsList = [];

        if (breadcrumbs) {
            breadcrumbs
                .sort((a, b) => a.category_level - b.category_level)
                .forEach((crumb) => {
                    const {
                        category_url, category_name, category_is_active, category_level
                    } = crumb;

                    // TODO use config once available
                    // do not add link to inactive categories or level 2 and 3
                    // eslint-disable-next-line no-magic-numbers
                    if (category_level === 2 || category_level === 3) {
                        breadcrumbsList.push({
                            name: category_name,
                            url: {
                                pathname: false,
                                state: { category: true }
                            }
                        });
                    } else if (category_is_active) {
                        breadcrumbsList.push({
                            name: category_name,
                            url: {
                                pathname: category_url,
                                state: { category: true }
                            }
                        });
                    } else {
                        breadcrumbsList.push({
                            url: '',
                            name: category_name
                        });
                    }
                });
        }

        return [
            { url, name },
            ...breadcrumbsList.reverse()
        ];
    }
}

export default new BreadcrumbsDispatcher();
